export default __webpack_public_path__ + "static/media/games-active.1faba568.webp";